import { el, escape } from './dom';

const HOST_ID = 'anomia-toast-host';

const ensureHost = (): HTMLElement => {
  let host = document.getElementById(HOST_ID);
  if (!host) {
    host = document.createElement('div');
    host.id = HOST_ID;
    document.body.append(host);
  }
  return host;
};

export type ToastKind = 'error' | 'info';

export type ToastHandle = {
  update(message: string): void;
  dismiss(): void;
};

export const toast = (
  message: string,
  kind: ToastKind = 'info',
  durationMs = 6000,
): ToastHandle => {
  const host = ensureHost();
  const node = el(`<div class="toast toast-${kind}" role="status">${escape(message)}</div>`);
  host.append(node);
  let timer: number | null = null;
  const dismiss = (): void => {
    if (timer !== null) {
      clearTimeout(timer);
      timer = null;
    }
    node.remove();
  };
  const update = (next: string): void => {
    node.textContent = next;
  };
  node.addEventListener('click', dismiss);
  if (durationMs > 0) {
    timer = window.setTimeout(dismiss, durationMs);
  }
  return { update, dismiss };
};
